/**
 * Where Clerk lands every completed sign-in AND sign-up (ClerkProvider
 * fallbacks, the `/sign-in` and `/sign-up` pages, the marketing auth modal).
 *
 * One path for both because Clerk's combined sign-in-or-up modal and its
 * organization task do not reliably pick the sign-up redirect for a new
 * account: a fresh signup landed on `/home`, painted the app shell, and only
 * then redirected to setup. `app/(auth)/continue/route.ts` decides setup vs
 * home on the server and answers with a plain redirect, so nothing paints
 * until the person reaches the right surface.
 */
export const POST_AUTH_LANDING_PATH = '/continue'
